import './OrderRequestMessageComposer.scss';
import { Base_RequestMessageComposer } from '../../Page_BaseSandbox/Base_RequestMessageComposer/index.js';
import { ModuleFE_SandboxOrders } from '../../modules/ModuleFE_SandboxOrders/index.js';
export class OrderRequestMessageComposer extends Base_RequestMessageComposer {
    static defaultProps = {
        module: ModuleFE_SandboxOrders,
    };
    sendRequest(template) {
        if (this.state.templateString.length === 0) {
            this.logError('Can\'t send empty orders');
            return;
        }
        ModuleFE_SandboxOrders.sendRequestToEpicWindow(template);
    }
}
//# sourceMappingURL=OrderRequestMessageComposer.js.map